<template>
  <div>
    <div class="knowledge-gallery">
      <title class="title-bar2">Saved Knowledge</title>
      <ul class="knowledge-list">
        <li v-for="(item, index) in savedKnowledge" :key="item.title" class="knowledge-item">
  <!-- Displaying item.type with color -->
  <v-chip :style="{ backgroundColor: item.color }">
    {{ item.type }}
  </v-chip>
  <div><strong>{{ item.title }}:</strong> {{ item.prompt }}</div>
  <button class="action-btn mx-2" @click="$emit('edit-knowledge', item, index)">Edit</button>
  <button class="action-btn mx-2" @click="$emit('delete-knowledge', index)">Delete</button>
</li>
      </ul>
    </div>
    <v-spacer></v-spacer>
    <v-divider></v-divider>
    <div class="knowledge-gallery">
      <title class="title-bar2">Ask a Question</title>
      <input class="inputarea" type="text" v-model="userQuery" @keyup.enter="queryKnowledge" placeholder="Enter your query" />
      <v-icon :color="recordingStateColor" @click="promptUserAndStartRecording" v-if="!isRecording">mdi-microphone</v-icon>
      <v-icon :color="recordingStateColor" @click="stopRecording" v-if="isRecording">mdi-microphone</v-icon>
      <button class="action-btn" @click="queryKnowledge">Search</button>
      <button class="action-btn" @click="resetQuery">Reset</button>
    </div>
<br />

<p v-if="queryResult">{{ queryResult }}</p>
  </div>
</template>

<script>
export default {
  props: {
    savedKnowledge: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      userQuery: '',
      queryResult: null,
      speechSynthesisUtterance: null, // To hold the speech synthesis utterance object
      isRecording: false,
      recordingStateColor: 'green', // Initial color for the recording icon
    };
  },
  mounted() {
    this.readOutLoud("What do you want to know?", true); // Pass true to indicate w
    // Initialize the speech recognition API

    setTimeout(() => {
      this.promptUserAndStartRecording();
    }, 3000); // 3 seconds after page load
    this.initSpeechRecognition();
  },
  methods: {
    queryKnowledge() {
  // Reset the query result to null to ensure fresh search results are displayed
  this.queryResult = null;

  // Find the first knowledge item that includes the userQuery string in its prompt or title
  const matchingItem = this.savedKnowledge.find(item => 
    item.prompt.toLowerCase().includes(this.userQuery.toLowerCase()) || 
    item.title.toLowerCase().includes(this.userQuery.toLowerCase())
  );

  // If a matching item is found, set the queryResult to that item's prompt (or any other relevant data)
  if (matchingItem) {
    this.queryResult = matchingItem.prompt;
  } else {
    // If no matching item is found, you could set a default message
    this.queryResult = "No matching knowledge found.";
  }
  this.queryResult = `${this.queryResult}`;
  setTimeout(() => {
      this.readOutLoud(this.queryResult);
    }, 2000);
    setTimeout(() => {
  this.resetQuery(); // Automatically reset after the message is read out loud
}, 15000);
    },
    resetQuery() {
  this.userQuery = ''; // Clear the query input field
  this.queryResult = null; // Optionally clear the query result if desired
},
    readOutLoud(msg) {
      if (window.speechSynthesis.speaking) {
        window.speechSynthesis.cancel(); // Stop any currently speaking synthesis
      }
      this.speechSynthesisUtterance = new SpeechSynthesisUtterance(msg);
      const voiceName = 'Google UK English Male';
      this.speechSynthesisUtterance.voice = speechSynthesis.getVoices().filter(voice => voice.name === voiceName)[0];
      this.speechSynthesisUtterance.volume = 1;
      this.speechSynthesisUtterance.rate = 1;
      this.speechSynthesisUtterance.pitch = 1;
      
      window.speechSynthesis.speak(this.speechSynthesisUtterance);

      // Event listener for the speech synthesis to handle custom stop functionality
      this.handleVoiceStop();
    },
    promptUserAndStartRecording() {
      
  if ('SpeechRecognition' in window || 'webkitSpeechRecognition' in window) {
    // Use the SpeechRecognition interface for the Web Speech API
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    const recognition = new SpeechRecognition();

    recognition.lang = 'en-US'; // Set the language
    recognition.interimResults = false; // We only want final results
    recognition.maxAlternatives = 1; // We only need the top match

    recognition.start(); // Start recognizing speech

    recognition.onstart = () => {
      this.isRecording = true;
      this.recordingStateColor = 'blue'; // Change the icon color to indicate recording
      console.log("Speech recognition started");
    };

    recognition.onresult = (event) => {
      // The SpeechRecognitionEvent results property returns a SpeechRecognitionResultList object
      // The SpeechRecognitionResultList object contains SpeechRecognitionResult objects.
      // It has a getter so it can be accessed like an array
      // The [0] returns the SpeechRecognitionResult at position 0.
      // We then return a SpeechRecognitionAlternative object that contains the final transcript
      const transcript = event.results[0][0].transcript;
      this.userQuery = transcript; // Assign the transcribed text to userQuery
      recognition.stop(); // Stop recognizing speech
      this.queryKnowledge(); // Automatically query after receiving voice input
    };

    recognition.onerror = (event) => {
      console.error('Speech recognition error', event.error);
      this.isRecording = false;
      this.recordingStateColor = 'green'; // Reset icon color
    };

    recognition.onend = () => {
      console.log("Speech recognition ended");
      this.isRecording = false;
      this.recordingStateColor = 'green'; // Reset icon color
    };
  } else {
    console.log("Speech recognition not supported");
    // Handle browsers that do not support SpeechRecognition here
    alert("Your browser does not support speech recognition. Please type your query.");
  }
},
startRecording() {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    const recognition = new SpeechRecognition();
    recognition.lang = 'en-US';
    recognition.start();

    recognition.onstart = () => {
      this.recordingStateColor = 'blue'; // Color when user is speaking
    };

    recognition.onresult = (event) => {
    
      this.imagePrompt = event.results[0][0].transcript;
      this.recordingStateColor = 'red'; // Color just before submitting
      setTimeout(() => {
        this.generateImage();
        this.isRecording = false;
        this.recordingStateColor = 'blue'; // Reset color after submitting
      }, 1000);
    };

    recognition.onerror = (event) => {
      console.error('Speech recognition error', event);
      this.isRecording = false;
    };

    this.isRecording = true;
  },
    stopRecording() {
    this.isRecording = false;
    this.recordingStateColor = 'blue'; // Reset color when stopped
    // Logic to stop recording. This depends on your implementation of SpeechRecognition.
    // If you've stored the instance of SpeechRecognition in a variable, call stop() on it.
  },

    handleVoiceStop() {
      // Implement voice stop functionality
      // This is a placeholder for the logic to stop reading out loud based on a voice command
      // Actual implementation will require integration with a voice recognition API/library
    },


  },
  emits: ['edit-knowledge', 'delete-knowledge'],
};
</script>

<style>
.question {
  margin-top: -1100px; 
  margin-left: 1400px;
  font-size: 20px;
  color: white;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  padding: 20px;
}

.title-bar {
  display: flex;
  justify-content: space-between;
  margin-left: 0px;
  margin-right: 0px;
  align-items: center;
  margin-bottom: 20px;
  background:-moz-linear-gradient(0deg, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0) 100%);
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  padding: 20px;
  font-size: 24px;
  color: rgb(79, 121, 80);
  width: 100%;
  max-width: 1920px;
  height: 100%;
  max-height: 1920px;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
.title-bar2 {
  display: flex;
  justify-content: space-between;
  margin-left: 0px;
  margin-right: 0px;
  align-items: center;
  margin-bottom: 20px;
  background:-moz-linear-gradient(0deg, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0) 100%);
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  padding: 20px;
  font-size: 24px;
  color: rgb(79, 121, 80);
  width: 25%;
  max-width: 1920px;
  height: 100%;
  border-radius: 10px;
}
.knowledge-gallery {
  padding: 20px;
  width: 1620px;
  background: #131f25e7;
	background-size: cover;
	background-position: center center;
	background-attachment: fixed;
	display: flex;

    -webkit-animation: gradient 25s ease infinite;
    -animation: gradient 25s ease infinite;
  }
    @-webkit-keyframes gradient {
      0% {
        background-position: 0% 50%;
      }
      50% {
        background-position: 100% 50%;
      }
      100% {
        background-position: 0% 50%;
      }
    }
  
    @keyframes gradient {
      0% {
        background-position: 0% 50%;
      }
      50% {
        background-position: 100% 50%;
      }
      100% {
        background-position: 0% 50%;
      }
      height: 150%;
    }

.knowledge-list {
  list-style-type: none;
  padding: 0;
  width: 1800px;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: 1.2rem;
}

.knowledge-item {
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 20px;
  width: calc(70% - 0px); /* Adjust width for better readability */
  box-sizing: border-box;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.knowledge-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 16px rgba(0, 0, 0, 0.2);
}

.action-btn {
  border: none;
  padding: 8px 8px;
  border-radius: 5px;
  cursor: pointer;
  background-color: #007bff;
  color: white;
  margin-left: 10px; /* Adjust margin to match mx-2 */
  width: 150px;
}

.action-btn:hover {
  background-color: #0056b3;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
    transform: scale(0.95);
  }
  50% {
    opacity: 0.5;
    transform: scale(1.02);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

.fade-in-animation {
  animation: fadeIn 1s ease forwards;
}
.v-btn {
  margin: 5px;
  color: gradient (red, blue);
}
.v-text-field, .v-textarea {
  margin: 10px 0;
}
.inputarea {
  width: 100%;
  padding: 18px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  resize: vertical;
  margin-top: 30px;
}
</style>
